/* BATCHA / 5.10 Campaign Grid behaviour: live-tile countdowns and the opt-in
   reveal. Split out of sections/campaign-grid.liquid in Section Templates v3.3.
   The grid carries no Klaviyo capture. Notify CTAs are plain links to the vote
   sections that own those captures (Klaviyo Flows v2.11). */
(function () {
  if (window.batchaCampaignGrid) return;
  window.batchaCampaignGrid = true;

  function padTwo(n) { return n < 10 ? '0' + n : '' + n; }

  function updateCountdowns() {
    document.querySelectorAll('.cg [data-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(target)) { el.textContent = ''; return; }
      var diff = target - Date.now();
      if (diff <= 0) { el.textContent = 'LIVE'; return; }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      el.textContent = d + 'D ' + padTwo(h) + 'H ' + padTwo(m) + 'M';
    });
  }

  function reveal() {
    var els = document.querySelectorAll('.cg.reveal-pending');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.remove('reveal-pending'); el.classList.add('reveal-done'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.remove('reveal-pending');
          e.target.classList.add('reveal-done');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) { obs.observe(el); });
  }

  function boot() { updateCountdowns(); reveal(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  setInterval(updateCountdowns, 1000);
  document.addEventListener('shopify:section:load', boot);
})();
